import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=df28fdaa&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=df28fdaa&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df28fdaa')) {
      api.createRecord('df28fdaa', component.options)
    } else {
      api.reload('df28fdaa', component.options)
    }
    module.hot.accept("./Menu.vue?vue&type=template&id=df28fdaa&", function () {
      api.rerender('df28fdaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/Menu.vue"
export default component.exports